export const GENERIC_ERROR_MESSAGE = "Something went wrong. Please try again.";

const extractedMessage = (message, fallback) => (
  message.trim() === "" && typeof fallback === "string" ? fallback : message
);

const isNonBlankString = (message) => (
  typeof message === "string" && message.trim() !== ""
);

export const errorDetail = (detail, fallback) => {
  if (typeof detail === "string") return extractedMessage(detail, fallback);
  const candidate = [detail?.message, detail?.detail, detail?.error, detail?.msg]
    .find(isNonBlankString);
  if (candidate !== undefined) return candidate;
  if (Array.isArray(detail)) {
    const messages = detail
      .map((item) => [item, item?.msg, item?.message].find(isNonBlankString))
      .filter(isNonBlankString);
    if (messages.length > 0) return messages.join(" ");
  }
  return typeof fallback === "string" ? fallback : GENERIC_ERROR_MESSAGE;
};
